
import { defineComponent } from 'vue'
import { IProductFeatureListItem } from '../../../../domain/IProductFeatureListItem'

export default defineComponent({
  name: 'PProductFeatureList',
  props: {
    items: {
      type: Array as () => IProductFeatureListItem[],
      default: () => [],
    },
  },
})
